export default __webpack_public_path__ + "static/media/vitaline.e800318f.png";